import { render, staticRenderFns } from "./SupervisorLayout.vue?vue&type=template&id=7abc987a&scoped=true"
import script from "./SupervisorLayout.vue?vue&type=script&lang=ts"
export * from "./SupervisorLayout.vue?vue&type=script&lang=ts"
import style0 from "./SupervisorLayout.vue?vue&type=style&index=0&id=7abc987a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc987a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
